export default {
  state: {
    versaoProjeto: process.env.PACKAGE_VERSION
  },
  getters: {
    getVersaoProjeto: state => state.versaoProjeto
  }
};
